import { Avatar } from "antd";
import React from "react";
import { cloudFrontUrl } from "../../nestserver";

/**
 * Avatar + name (+ optional subtitle line) for a Group Console table row.
 * Shared by Students/Instructors/Parents so "better info" means one real
 * component, not three copies of the same image-fallback logic.
 */
export default function PersonCell({ id, image, firstName, lastName, subtitle }) {
  const name = [firstName, lastName].filter(Boolean).join(" ") || "—";
  const src = image
    ? `${cloudFrontUrl}/${id}/${image}`
    : `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=random`;

  return (
    <div className="flex items-center gap-2 text-left">
      <Avatar src={src} size={32}>
        {name?.[0]?.toUpperCase()}
      </Avatar>
      <div className="min-w-0">
        <div className="font-medium text-gray-800 truncate">{name}</div>
        {subtitle && (
          <div className="text-xs text-gray-400 truncate">{subtitle}</div>
        )}
      </div>
    </div>
  );
}
